import buildRepositories from '@/api_repository/repositories_builder.js'

export default (_, inject) => {
  inject('repositories', buildRepositories)
  inject('apiConfig', {
    TYPEAHEAD_MIN_QUERY_LENGTH: 3
  })
}